import { render, staticRenderFns } from "./levelPaymentFrequency.vue?vue&type=template&id=b36b2a7a&scoped=true&"
import script from "./levelPaymentFrequency.vue?vue&type=script&lang=js&"
export * from "./levelPaymentFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36b2a7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b36b2a7a')) {
      api.createRecord('b36b2a7a', component.options)
    } else {
      api.reload('b36b2a7a', component.options)
    }
    module.hot.accept("./levelPaymentFrequency.vue?vue&type=template&id=b36b2a7a&scoped=true&", function () {
      api.rerender('b36b2a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/roleOccupationPaymentRate/levelPaymentFrequency.vue"
export default component.exports